import { render, staticRenderFns } from "./Subformulario.vue?vue&type=template&id=a79c68a2"
import script from "./Subformulario.vue?vue&type=script&lang=js"
export * from "./Subformulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports